if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
// Func = limiting Scope for this file
var lastScrollTop = 0;
var page = 1, items_by_page = 6, config = null, pinsData=[],GOOGLE_MAPS_WRAPPER=null,MAP,HOTEL_PIN,GoogleMapsMarkers = [],$GoogleMaps = [];
var bottomScroll = document.body.scrollHeight;
var getOffersAction = "pager";
var wait_next_request = false;
var locationFilter = "";
let listHotelMarshas = [];
let addedMarshas = new Set();

function scrollDown(){
    bottomScroll = document.body.scrollHeight;
    var scrollTop = Number.parseInt( document.documentElement.scrollTop );
    var currentScroll = Number.parseInt( window.innerHeight );  

      if((bottomScroll-700) < (scrollTop + currentScroll) && !wait_next_request){
        wait_next_request = true;  
        getOffersAction = "pager";
        offers_page++;
        getOffers($('#blogId').val(), $('#blogIdMap').val(), ($('#locationFilter')!== undefined && $('#locationFilter').val()=='')?'City':$('#locationFilter').val());
        setTimeout(function(){
            wait_next_request = false;        
        }, 5000)
      }
  }

(function(){

	$(document).ready(function () {

		$('.header-languages__active').click(function(e){
			e.preventDefault();
			$(this).parent().find('.header-languages__options').toggleClass('active');
		});

		$('.primary-nav-6 a').attr('data-custom_click_track','NavBar |Activity Res Click|external|event455');
		$('.primary-nav-7 a').attr('data-custom_click_track','NavBar |Meeting RFP Click|external|event459');

        onloadOffers();

		let DATE_STYLE = [true];
		let op = 0;
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn--alt').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut--alt').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-edge';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		function calendarSelect (date) {
			let start = ($('#CheckIn--alt').val() !== '') ? $('#CheckIn--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date()),
				end = ($('#CheckOut--alt').val() !== '') ? $('#CheckOut--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
			let startDate = $.datepicker.parseDate(DATE_FORMAT, start);
			let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;
				$(this).val(start + ' - ');
				$(this).data().datepicker.inline = true;
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;
				} else {
					end =  date;
				}
				$(this).val(start + ' - ' + end);
				$(this).data().datepicker.inline = false;
			}
			$('#CheckIn--alt').val( start );
			$('#CheckOut--alt').val( end );
		}
		function calendarClose () {
			$(this).data().datepicker.inline = false;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = 'mm/dd/yy';
		$("#CheckInOut").datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: calendarRange,
			onSelect: calendarSelect,
			onClose: calendarClose
		});
		$("#CheckInOut").on('keyup', function(){
			const dates = $(this).val().split(' - ');
			$('#CheckIn--alt').val( dates[0] );
			$('#CheckOut--alt').val( dates[1] );
		});

		// Remove empty <p> tags created by tinymce
		const paragraph = document.querySelectorAll('p') || [];
		paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	
	
		$('.sym-slides').slick({
			accessibility: false
		});

		$('.burger,.nav__close').click(function() {
			$('.nav').toggleClass('open');
		});

		$('.scrollto').click(function () {
            let target = $(this).attr("href");
            $('html, body').animate({scrollTop: $(target).offset().top - 100}, 1000);
            return false;
        });

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});
       
	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
    //showMap();
}());

function onloadOffers(){
	GOOGLE_MAPS_WRAPPER = document.querySelector("#offers_map");
	$('.processing').show();
	let blogId = $('#blogId').val();
	let blogIdMap = $('#blogIdMap').val();
	locationFilter = ($('#locationFilter')!== undefined && $('#locationFilter').val()=='')?'City':$('#locationFilter').val();
	getOffersAction = "pager";
	getOffers($('#blogId').val(), $('#blogIdMap').val(),locationFilter);
} 

function showMap(){
    //Maps
    let map_btn = document.querySelector('.offers-search__options .map');
    let grid_btn = document.querySelector('.offers-search__options .grid');
    if(map_btn){
        map_btn.addEventListener('click', function(event){
            event.preventDefault();
            document.querySelector('.offers-search__list').classList.remove('grid-view');
            document.querySelector('.offers-search__list').classList.add('map-view');

            document.querySelector('.offers-search').classList.remove('grid-view');
            document.querySelector('.offers-search').classList.add('map-view');

            grid_btn.classList.remove('active');
            map_btn.classList.add('active');
            //init google maps
            //console.log('config',config,'pinsData',pinsData);
            LoadGoogleMaps(config,pinsData);
            matchOfferWithMarkers();
        });
    }

    
    if(grid_btn){
        grid_btn.addEventListener('click', function(event){
            event.preventDefault();
            document.querySelector('.offers-search__list').classList.remove('map-view');
            document.querySelector('.offers-search__list').classList.add('grid-view');

            document.querySelector('.offers-search').classList.remove('map-view');
            document.querySelector('.offers-search').classList.add('grid-view');
            grid_btn.classList.add('active');
            map_btn.classList.remove('active');
        });
    }
    
    if (document.querySelector('form#booking-form #states_loc')) {
        
        let selectFormLocation = document.querySelector('form#booking-form #states_loc');
        selectFormLocation.addEventListener('change', function() {
            let listHotels = [];
            let selectedOption = this.options[this.selectedIndex];
            let valueLocationSelectV = document.getElementById('locationSelect');
            valueLocationSelectV.value = selectedOption.value;
            
            listHotelMarshas.forEach(  (element) =>  { 
                if ( element.location === selectedOption.dataset.filter )
                    return listHotels.push( element.marsha );
            });
            document.getElementById('hotelList').value = listHotels.join(', ');
        });
    }


    if(document.querySelector('#booking-active')) {
        let closeBookingModule	= document.querySelector('.nav__close-booking');	
        closeBookingModule.addEventListener('click', function () {
            bookingModule.classList.remove('open');
        })
        let bookingModule = document.querySelector('.bookingModule');	
        let actionBooking =	document.querySelector('#booking-active');
        actionBooking.addEventListener('click', function () {
            bookingModule.classList.add('open');
        })
    }
}

function goPage( num, object ){
      
	if(object != undefined){
		$( ".paginator a" ).removeClass( "active" );
		$( object ).addClass( "active" );
	}
	
	var first_item = items_by_page * num;
	var last_item = first_item + items_by_page;
	$.each( $( ".offers-search__col.div" ), function( index, value ){

		if( index < first_item )
			$( value ).css( "display", "none" );
		else if( index >= first_item && index < last_item )
			$( value ).css( "display", "flex" );
		else
			$( value ).css( "display", "none" );

	} )
	const first = (num+1);
	let  lostNum = 1;
	if(first>1)
		lostNum = (num*items_by_page)+1;
	const total = $( ".offers-search__col.div" ).length;
	const length= first*items_by_page;
	

	return false;
}
 
function generatePaginator(){

	$( ".paginator" ).remove();

	var count = $('.offers-search__col.div').length;
	var html = "<div class='paginator'>";
	var floor = count/items_by_page;
	if(count>items_by_page){
		for( var i = 0 ; i <  floor ; i++ ){
			html += "<a href='#result-list' ";
			if(i == 0) { html += 'class="active"';}
			html += " onclick='goPage("+i+", this)'>" + (i+1) + "</a> ";
		}
	}
	html += "<div>";

	$( "#result-list" ).append( html ); 
}

var listeners_select_added = false;
var listeners_select_city_added = false;
function generateSelectHtml(){

  if(listeners_select_added)
	  return;

  listeners_select_added = true;    

	//custom select functionality;
	const custom_select = document.getElementsByClassName('custom-select');
	if(custom_select){

		for(let i = 0; i < custom_select.length; i++ ){
			let custom_select_current = custom_select[i].querySelector('.custom-select__current');
			custom_select_current.addEventListener('click', function(e){
				offers_page=0;
				if(custom_select[i].classList.contains('active')){
					custom_select[i].classList.remove('active');
				}else{
					for(let x = 0; x < custom_select.length; x++ ){
						custom_select[x].classList.remove('active');
					}
					custom_select[i].classList.add('active');
				}
				
			})
		}

		
	}
}

function removeDuplicateHtml(names, type, format = null) {
    let uniqueNames = [];
    let html = '';
  
    if (Array.isArray(names) && names.length > 0) {
      if (typeof names[0] === 'object') {
        
        const seen = new Set();
        uniqueNames = names.filter((item) => {
          if (!seen.has(item.key)) {
            seen.add(item.key);
            return true;
          }
          return false;
        });
  
        
        uniqueNames.sort((a, b) => {
          if (a.name && b.name) {
            return a.name.localeCompare(b.name);
          }
          return 0; 
        });
      } else {
        
        uniqueNames =[...new Set(names.filter(name => name !== null))];
  
        
        uniqueNames.sort((a, b) => {
          if (a && b) {
            return a.localeCompare(b);
          }
          return 0; 
        });
      }
    }
  
    let key = null, name = null;
  
    
    switch (type) {
      case 'li':
        uniqueNames.forEach((element) => {
          if (typeof element === 'object' && element != null) {
            key = encodeURIComponent(element.key.trim());
            name = element.name;
          } else if (element != null) {
            if (element.indexOf("__") != "-1") {
              let key1 = element.split("__");
              key = key1[1];
              name = key1[0];
            } else {
              key = encodeURIComponent(element.trim());
              name = element;
            }
          }
  
          if (name != "null" && name != null && name != "" && name) {
            html += '<a data-filter="' + key + '">' + name + '</a>';
          }
        });
        break;
  
      default:
        uniqueNames.forEach((element) => {
          if (typeof element === 'object' && element !== null) {
            key = element.key != null ? encodeURIComponent(element.key.trim()) : null;
            name = element.name;
          } else {
            key = element ? encodeURIComponent(element.trim()) : null;
            name = element;
          }
  
          if (name != "null" && name != null) {
            html += '<option data-filter="' + key + '" value="' + name + '">' + name + '</option>';
          }
        });
        break;
    }
  
    return html;
  }

var filters_loaded = false;

let dpkr = '';

let filter = {
  location: null,
  city: null,
  type:null,
  brand: null
};
let filter2 = {
  location: null,
  type:null,
  brand: null
};

let filter3 = {
  location: null,
  type:null,
  brand: null
};

function offersFilter(data, locationFilter){

  if (!$('#hotelList').val()) {
	  $('#hotelList').val(config.marsha_code);
  }
  //html offer search
  let allText = lang=='fr'?'Tout':'All';
  let locationText = lang=='fr'?'emplacement':'Location';
  //Elements of drop downs.
  let locations 	= '<a data-filter="all">'+allText+'</a>';
  let typeHotels	= '<a data-filter="all" >'+allText+'</a>';
  let cities      = '<a data-filter="all" >'+allText+'</a>';
  let countries      = '<a data-filter="all" >'+allText+'</a>';
  let brands 		= '<a data-filter="all">'+allText+'</a>';
  let states      = `<option value="all">${locationText}</option>`;
  let filters 	= data.data.filters;
  let typeArray	= [], locationsArray =[], brandsArray=[],stateArray=[],citiesArray=[],countryArray=[];

  filters.forEach(element =>{
	  let typeData	= (element.type!=null && element.type!='---')? element.type.split("|") : [];
	  typeArray		= typeArray.concat(typeData);

	  if(element.bill_city!==null && element.bill_city!==undefined )
		  citiesArray.push(element.bill_city);
	  if(element.bill_country!==null && element.bill_country!==undefined )
		countryArray.push(element.bill_country);
	  if(locationFilter=='City' && element.bill_city!==null && element.bill_city!==undefined ){
		  locationsArray.push(element.bill_state_co);
		  citiesArray.push(element.bill_city);
	  }else if(locationFilter=='State' && element.bill_state!==null && element.bill_state!==undefined ){
		  stateArray.push(element.bill_state_co );    
		  locationsArray.push(element.bill_state_co);
	  }else if(locationFilter=='Market' && element.market!==null && element.market!==undefined )
		  locationsArray.push(element.market);
		  
	  if(element.portfolio!==null && element.portfolio!==undefined&& element.portfolio !=''&& element.portfolio !='All')
		  brandsArray.push(element.portfolio);
  });

  //Remove Duplicates
  typeHotels	+= removeDuplicateHtml(typeArray,'li');
  locations		+= removeDuplicateHtml(locationsArray,'li');
  brands 		+= removeDuplicateHtml(brandsArray,'li');
  states      	+= removeDuplicateHtml(stateArray,'li');
  cities      	+= removeDuplicateHtml(citiesArray,'li');
  countries      	+= removeDuplicateHtml(countryArray,'li');


	if (filters_loaded) {
		/*$('#states_loc').html(states);
		$('#city').html(cities);*/
	} else {
		//console.log('locations',locations,'states',states,'Cities',cities,'locationsArray',locationsArray);
		const uniqueLocations = [...new Set(citiesArray.filter(location => location !== "Washington, DC" && location !== "Washington D.C."))];
		const stateLocations =  '<option value="all">'+locationText+'</option>'+removeDuplicateHtml(uniqueLocations);
		$('#location').html(locations);
		$('#typeHotel').html(typeHotels);
		$('#states_loc').html(stateLocations);
		$('#city').html(cities);
		$('#country').html(countries);
	}

  filters_loaded = true;
  
  const type_hotels_li = document.querySelectorAll('#typeHotel li');
  if(type_hotels_li){
	  if(lang == 'fr'){
		  for(let l = 0; l < type_hotels_li.length; l++){
			  switch(type_hotels_li[l].innerHTML){
				  case'City':
				  type_hotels_li[l].innerHTML = 'Ville';
				  break;
			  }
		  }
	  }
  }

  $('#brand').html(brands);

  generateSelectHtml();
  

  // offer items lightbox
  $('.offers-search__item .offers-search__btn-resere').on('click',function(event){
	  event.preventDefault();
	  if(dpkr != ''){
		  dpkr.clear();
		  dpkr.destroy();
		  $('.date_in, .date_out').html('');
		  $('#check-in-out').prop('readonly',false);
	  }
	  
	  let elem=$(this).parent().parent().parent().parent().data('key');
	  $('#reserve-lightbox .title').html(pinsData[elem].name);
	  $('#reserve-lightbox .description').html(pinsData[elem].description);
	  $('#reserve-lightbox .address').html(pinsData[elem].address+'<br>'+pinsData[elem].state+', '+pinsData[elem].city);
	  $('#reserve-lightbox .phone').html(pinsData[elem].link_tel);
	  $('#reserve-lightbox .phone').attr('href','tel:'+pinsData[elem].link_tel);
	  $('#reserve-lightbox .website').attr('href',pinsData[elem].website);
	  $('#reserve-lightbox form #propertyCode').val(pinsData[elem].marsha);
	  if(pinsData[elem].booking_url.length > 0){
		  $('#hrefBookingUrl').attr('href',pinsData[elem].booking_url);
		  $('#idFormLightbox').addClass('hidden')
		  $('#booking_url').removeClass('hidden')
	  }else{
		  $('#hrefBookingUrl').attr('href','#');
		  $('#idFormLightbox').removeClass('hidden')
		  $('#booking_url').addClass('hidden')
	  }
	  //$('#reserve-lightbox form #corporateCode').val(pinsData[elem].promo);
	  $('#reserve-lightbox').appendTo($(this).parent().parent().parent().siblings('.offers-search__box'));
	  $('.offers-search__col').removeClass('active');
	  $(this).parent().parent().parent().parent().addClass('active');
	  const this_box_height = $(this).parent().parent().parent().siblings('.offers-search__box').innerHeight();
	  $('.offers-search__col').css('margin-bottom',0);
	  $(this).parent().parent().parent().parent().css('margin-bottom',this_box_height+15);

	  const thisTop = $(this).offset().top;
	  $('html,body').animate({
		  scrollTop: thisTop
	  },1200);

	  window.location.hash=elem;

	  var inputBooking = document.querySelector('#check-in-out');
	  var monthNamesShort;
	  if(lang == 'en'){
		  var monthNamesShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	  }else{
		  var monthNamesShort = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Jui', 'Jui', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
	  }
	  setTimeout(function(){
		  dpkr = new HotelDatepicker(inputBooking,{
				  format: 'MM/DD/YYYY',
				  showTopbar: false,
				  moveBothMonths: true,
				  onSelectRange: function() {
					   if($('#check-in-out').val().length>0){
						  $('#check-in-out').prop('readonly',true);
					  }else{
						  $('#check-in-out').prop('readonly',false);
					  }
						  var date_val = dpkr.getValue().split(' - ');
						  document.getElementById('DateIn').setAttribute('value', date_val[0]);
						  document.getElementById('DateOut').setAttribute('value', date_val[1]);
						  var split_in = date_val[0].split('/');
						  var month_in = parseInt(split_in[0])-1;
						  //$('.date_in').html(`${monthNamesShort[month_in]}/${split_in[1]}/${split_in[2]}`);
						  $('.date_in').html(date_val[0]);
						  var split_out = date_val[1].split('/');
						  var month_out = parseInt(split_out[0])-1;
						  //$('.date_out').html(`${monthNamesShort[month_out]}/${split_out[1]}/${split_out[2]}`);
						  $('.date_out').html(date_val[1]);	
				  }
		  });
	  },200)
  
	  var open_datepicker_button = document.getElementById('open-datepicker');
	  open_datepicker_button.addEventListener('click', function(){
		  dpkr.open();
	  });
  });

  
  setTimeout(function(){
	  onloadReserve();
  },300)

  $('#reserve-lightbox .close').click(function(){
	  $('#reserve-lightbox').appendTo('.content-reserve');
	  $('.offers-search__col').removeClass('active').css('margin-bottom',0);
	  dpkr.clear();
	  dpkr.destroy();
	  $('.date_in, .date_out').html('');
  });

  let filter_classes = [];
  let filter_url = [];
  const custom_select_li = document.querySelectorAll('.custom-select a');


	  for(let l = 0; l < custom_select_li.length; l++ ){

		  $(custom_select_li[l]).off('click');
		  $(custom_select_li[l]).on('click', function(e){

			  offers_page = 0;
			  $(this).closest('.custom-select').removeClass('active');
			  $(this).closest('.custom-select').find('a').removeClass('li-selected');

			  //const this_siblings = this.closest('.custom-select').querySelectorAll('li');
			  const this_current_value = $(this).closest('.custom-select').find('.custom-select__current .value');
			  const this_html = this.innerHTML;
			  //setTimeout(function(){
			  custom_select_li[l].classList.add('li-selected');
			  //},0);
			  this_current_value.text(this_html);
			  const items_legth = document.querySelectorAll('.offers-search__item').length;
			  const this_data = $(this).data('filter');
			  const this_filter = $(this).closest('.custom-select').data('filter');
			  
			  if(this_data == 'all'){
				  filter[this_filter] = null;
				  filter2[this_filter] = null;
				  filter3[this_filter] = null;
				  $(this).closest('.custom-select').removeClass('selected');
			  }else{
				  $(this).closest('.custom-select').addClass('selected');
				  let this_html_class =  this_data;
				  filter[this_filter]  = this_filter+'-'+this_html_class;
				  filter2[this_filter] = this_html;
				  filter3[this_filter] = this_filter+'='+this_html_class;
			  }

			  //generate url parameters
			  filter_url = Object.values(filter3);
			  
			  let url_string = '';
			  for(let f = 0; f < filter_url.length; f++){
				  if(filter_url[f] !== null){
					  url_string += filter_url[f]+'&';
				  }
			  }
			  url_string = url_string.slice(0, -1)
			  //console.log(url_string);

			  window.history.replaceState(null, null, '?'+url_string);
			  
			  getOffersAction = "filter";
			  getOffers($('#blogId').val(), $('#blogIdMap').val(),locationFilter);

			  const offer_items = document.querySelectorAll('.offers-search__col');
			  for(let i = 0; i < offer_items.length; i++){
				  offer_items[i].style.display = 'none';
			  }
			  let totalItem  =0 ;

			  const selectedFilters = document.querySelectorAll('.custom-select.selected');
			  const countSelected = selectedFilters.length;
			  //console.log(countSelected);
			  if(countSelected > 0){
				  const selected_data_filter = selectedFilters[0].getAttribute('data-filter');
				  let filtered_all = document.querySelectorAll('.offers-search__col').length;
				  filtered_all = parseInt(filtered_all);
				  let filtered_active = '';
				  if(totalItem != filtered_all){
					  filtered_active = totalItem;
				  }else{
					  filtered_active = filtered_all;
				  }
				  const plural = filtered_all != 1 ? 's':'';
				  
			  }else{
				  document.getElementById('data-paginator').innerHTML = '';
			  }
		  
		  })
	  
  }
}

function onloadReserve(){
  let hash = window.location.hash.replace('#','');
  if(hash.length>0 && pinsData.length>0){
	  $('.offer-new[data-key='+hash+']').trigger('click');
  }
}

let LIGHTBOX__FULL_WRAPPER = document.querySelector("#offer-lightbox"),
    LIGHTBOX__CLOSE_BUTTON = "close--lightbox",
    $LIGHTBOX__CLOSE_BUTTON = document.querySelector(`#${LIGHTBOX__CLOSE_BUTTON}`),
    LIGHTBOX_WRAPPER = document.querySelector("#offer-ligthbox__content");
const LIGHTBOX_OPENED__CLASS = "opened-lightbox";	

let offers_count = 31;
var offers_page = 0;
var filterBrand = $( "#filterBrand" ).val();
var location_page = window.location.pathname;
function getOffers(blogId,blogIdMap,locationFilter){

	if($(".offers-search__col").length < offers_count )
		$('.processing').show();
	else if(offers_page != 0)
		return;

	$.get(`${site_url}ajax/functions.php?operation=getOffers&blogId=${blogId}&blogIdMap=${blogIdMap}&page=${offers_page}&brand=${filterBrand}`, function (data) {

		if (getOffersAction == "filter")
			$('#result-list').html('');

		if (data.result == 'success') {
			let htmlCol = '';
			let offers = data.data.offers;
			let filters = data.data.filters;
			offers_count = data.data.offers_total;

			//config maps
			config = data.data.config;

            
            if(offers_page == 0 || offers_page == 1){
                for (const [key, portfolio] of Object.entries(filters)) {
                    const locationLabel = portfolio.bill_city.replace(' ', '').replace('.', '').replace('é', '').replace("'", '').toLowerCase();
                    if (!addedMarshas.has(portfolio.marsha)) {
                        listHotelMarshas.push({ location: locationLabel, marsha: portfolio.marsha });
                        addedMarshas.add(portfolio.marsha);
                    }
                }
            }

			for (const [key, offer] of Object.entries(offers)) {

				const logoSrc = null,
					labelBookNow = offer.label_website;

				if (offer.brand !== null && offer.logo === null) {
					if(location_page == "/" && offer.brand == 'W Hotels') {
						logoSrc = '/assets/images/brand-logos/' + offer.brand.replace(/ /g, "-") + '-dark.svg';
					} else {
						logoSrc = '/assets/images/brand-logos/' + offer.brand.replace(/ /g, "-") + '.svg';
					}
					logoSrc = logoSrc.toLowerCase();
				} else if (offer.logo !== null)
					logoSrc = offer.logo


				let figures = '',
					imageSrc = ''
				if (typeof offer.images === 'object' && offer.images.length > 0) {
					imageSrc = offer.images[0].src;
					let imageAlt = offer.images[0] !== undefined ? offer.images[0].alt : '';
					offer.images.forEach(image => {
						//lengthImage = offer.images.length;
						figures += `<figure class="offer-new__image">`;
						figures += `<img loading="eager"  src="${image.src}" alt="${image.alt}">`
						figures += `</figure>`;
					});
				}

				const types = (offer.types == null || offer.types==='---')? '' : offer.types;
				let location = '',
					website = null,
					learnMoreUrl = '';
				if (locationFilter == 'City')
					location = offer.city == null ? '' : 'location-' + offer.city.toLowerCase().replace(/ /g, "_").replace(',', "-").replace(/\./g, "-").replace(/[^a-zA-Z ]/g, "");
				if (locationFilter == 'State')
					location = offer.state == null ? '' : 'location-' + offer.state.toLowerCase().replace(/ /g, "_").replace(',', "-").replace(/\./g, "-");
				else if (locationFilter == 'Market')
					location = offer.market == null ? '' : 'location-' + offer.market.replace(/ /g, "_").replace(',', "-").replace(/\./g, "-");

				const city = offer.city == null ? '' : 'city-' + offer.city.toLowerCase().replace(/ /g, "_").replace(',', "-").replace(/\./g, "-").replace(/[^a-zA-Z ]/g, "");
				if (city.length > 0)
					city = city.replace('.', '-');

				let brand = offer.brand == null ? '' : 'brand-' + offer.brand.toLowerCase().replace(/ /g, "_").replace(',', "-").replace(/\./g, "-").replace(/[^a-zA-Z ]/g, "");
				if (brand != '') {
					brand = brand.replace('.', '-');
				}

				if (offer.website == 'https://www.' && lang == "en") {
					website = `https://www.marriott.com/search/submitSearch.mi?clusterCode=corp&corporateCode=M96&searchType=HotelList&hotelList=${offer.marsha}&numberOfGuests=1&numberOfRooms=1`;
				} else if (lang != "en") {
					website = offer.link;
				} else {
					website = offer.link;
				}
				if (offer.custom1.length == 0) {
					if ( offer.brand && offer.brand.toLowerCase() == 'the ritz-carlton') {
						learnMoreUrl = `https://www.ritzcarlton.com?marshaCode=${offer.marsha}" data-key="${key}" target="_blank"  data-name="${offer.client_name}`;
					} else {
						learnMoreUrl = `https://marriottbonvoyevents.com/tour/${offer.marsha}" data-key="${key}" target="_blank"  data-name="${offer.client_name}`;
					}
				} else {
					learnMoreUrl = offer.custom1;
				}

				const link_tel = offer.phone == null ? '' : offer.phone.replace(/\D/g, "");

				htmlCol += '<div data-key=' + key + ' class="offers-search__col div ' + location + ' ' + city + ' ' + types + ' ' + brand + ' can-' + ( offer.city ? (offer.city.replace(".", "").replace(" ", "")).toLowerCase() : "" ) + '" data-marsha="' + offer.marsha + '">';
				htmlCol += ' <article data-key=' + key + ' class="offers-search__item offer-new" data-name="' + offer.client_name + '">';
				let totalImage = (offer.images != undefined) ? offer.images.length : 0;
				if (totalImage > 1) {
					htmlCol += '<div class="sym-offers">';
					htmlCol += `${figures}`;
					htmlCol += '</div>';
					htmlCol += `   <div class="offer-new__over">`
					if (offer.brand !== null) {
						htmlCol += `<div class="logo"><img src="${logoSrc}" alt="${offer.brand} logo"/></div>`
					}
					htmlCol += `   <div class="offer-new__over-bottom">`
					htmlCol += `  <a href="${learnMoreUrl}" target="_blank" class="btn custom_click_track" data-custom_click_track_value="Body: tile- ${offer.client_name}|Hotel Site Click|external|event450${offer.marsha}">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${website}" target="_blank" class="btn">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${learnMoreUrl}" class="learn-more">${data.data.config.label_learn_more}</a>`;
					htmlCol += `   </div>`;
					htmlCol += `   </div>`;
				} else if (totalImage == 1) {
					htmlCol += `${figures}`;
					htmlCol += `   <div class="offer-new__over">`
					if (offer.brand !== null) {
						htmlCol += `<div class="logo"><img src="${logoSrc}" alt="${offer.brand} logo"/></div>`
					}
					htmlCol += `   <div class="offer-new__over-bottom">`
					htmlCol += `  <a href="${learnMoreUrl}" target="_blank" class="btn custom_click_track" data-custom_click_track_value="Body: tile- ${offer.client_name}|Hotel Site Click|external|event450${offer.marsha}">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${website}" target="_blank" class="btn">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${learnMoreUrl}" class="learn-more">${data.data.config.label_learn_more}</a>`;
					htmlCol += `   </div>`;
					htmlCol += `   </div>`;

				} else {

					htmlCol += '<figure class="offer-new__image no-image">';
					//htmlCol += '<img src="'+imageSrc+'" alt="">';

					htmlCol += '   <div class="offer-new__over">';
					if (offer.brand !== null) {
						htmlCol += '		<img src="' + logoSrc + '" alt="${offer.brand} logo">';
					} 
					htmlCol += `   <div class="offer-new__over-bottom">`
					htmlCol += `  <a href="${learnMoreUrl}" target="_blank" class="btn custom_click_track"  data-custom_click_track_value="Body: tile- ${offer.client_name}|Hotel Site Click|external|event450${offer.marsha}">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${website}" target="_blank" class="btn">${labelBookNow}</a>`;
					//htmlCol += `  <a href="${learnMoreUrl}" class="learn-more">${data.data.config.label_learn_more}</a>`;
					htmlCol += `   </div>`;
					htmlCol += '   </div>';

					htmlCol += '   </figure>';
				}
				htmlCol += '  <div class="offer-new__title">';

				htmlCol += '    <div class="offer-new__hotel brand-font">' + offer.title2 + '</div>';
				htmlCol += ( offer.city && offer.state ) ? ( '<div class="offer-new__address">' + ( offer.city ? offer.city : "" ) + ', ' + ( offer.state ? offer.state : "" ) ) + '</div>' : "";
				htmlCol += '<ul>';
				htmlCol += ( offer.custom3 ) ? '<li class="rooms">' + offer.custom3 + '</li>' : "";
				htmlCol += ( offer.custom4 ) ? '<li class="size">' + offer.custom4 + '</li>' : "";
				htmlCol += '</ul>';

				htmlCol += '  </div>';
				htmlCol += ' </article>';
				htmlCol += ' <div class="offers-search__box"></div>';
				htmlCol += '</div>';
				//load Pines Data

				pinsData[key] = {
					'id': key,
					'city': offer.city,
					'name': offer.client_name,
					'description': offer.description,
					'lat': offer.latitude,
					'long': offer.longitude,
					'address': offer.address,
					'logo': logoSrc,
					'image': (typeof imageSrc === undefined) ? '------' : imageSrc,
					'phone': offer.phone,
					'link_tel': link_tel,
					'promo': offer.promo_code,
					'marsha': offer.marsha,
					'website': offer.website,
					'booking_url': offer.booking_url
				};
			}

			for (const [key, offer] of Object.entries(data.data.filters)) {
				const logoSrc = '',
					labelBookNow = offer.label_website;

				let imageSrc = ''
				if (typeof offer.images_src === 'object' && offer.images_src.length > 0) {
					imageSrc = offer.images_src[0].src;
				}
				let link_tel = offer.phone == null ? '' : offer.phone.replace(/\D/g, "");

				if (offer.client_name !== null && offer.logo === null) {
					logoSrc = '/assets/images/brand-logos/' + offer.client_name.replace(/ /g, "-") + '.svg';
					logoSrc = logoSrc.toLowerCase();
				} else if (offer.logo !== null)
					logoSrc = offer.logo

				pinsData[key] = {
					'id': key,
					'city': offer.city,
					'name': offer.client_name,
					'description': offer.description,
					'lat': offer.latitude,
					'long': offer.longitude,
					'address': offer.address,
					'logo': logoSrc,
					'image': (typeof imageSrc === undefined) ? '------' : imageSrc,
					'phone': offer.phone,
					'link_tel': link_tel,
					'promo': offer.promo_code,
					'marsha': offer.marsha,
					'website': offer.website,
					'booking_url': offer.booking_url
				};
			}

			$('#result-list').html($('#result-list').html() + htmlCol);

			const items = document.querySelectorAll('.offers-search__col');
			let totalActivesItem = 0;
			items.forEach(item =>{
				if(item.getAttribute('style')===null)
					totalActivesItem++;
			});

			document.getElementById('data-paginator').innerHTML = 'Showing ' + (totalActivesItem) + ' of ' + offers_count + ' Hotels';
			$('.processing').hide();

			$('.sym-offers').slick({
				accessibility: false,
				dots: false,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true
			});

		}

	  if(offers_page==0 || getOffersAction == "pager"){
		  offersFilter(data, locationFilter);
          if(offers_page==0)
            LoadGoogleMaps(config,pinsData);
	  }    

	  $('.processing').hide();  
  },"json");
}

/**************************************************************************************************************************************************************
 * GOOGLE MAPS
 ****************************************************************************************************************************************************************/
function LoadGoogleMaps(config, pins) {
    let markerCluster;

	const InitializeMap = (lat, long, zoom = 13, styles) => {

		//SET POSITION OF MAP
		let PinPosition = new google.maps.LatLng(lat, long); //set longitude and latitude

		// option for google map object
		let myOptions = {
			zoom: 4,
			center: PinPosition,
			mapTypeId: "roadmap",
			mapTypeControl: false,
			styles: (styles!='')?JSON.parse(styles):{},
			scrollwheel: false,
			disableDoubleClickZoom: false,
			backgroundColor: '#ffffff',
			panControl: false,
			zoomControl: true,
			zoomControlOptions: {
			position: google.maps.ControlPosition.RIGHT_CENTER
			}
		};


		// create new map make sure a DIV with id myMap exist on page
		MAP = new google.maps.Map(GOOGLE_MAPS_WRAPPER, myOptions), //generate map into div id myMap
        HOTEL_PIN = {
            id: "hotel",
            map: MAP,
            title: config.hotel_name,
            icon: config.hotel_pin.pin,
            zIndex: 2,
            //animation: google.maps.Animation.BOUNCE,
            position: new google.maps.LatLng(config.hotel_pin.lat, config.hotel_pin.long)
        };
		// create new marker
		//new google.maps.Marker(HOTEL_PIN);
        const markers = [];
		pins.forEach(pin => {
			let marker = loadMarker(pin, MAP, config.regular_pin.normal);
            markers.push(marker);
			GoogleMapsMarkers.push(marker);
			// this shows the name of each pin when hover
			//hoverPin(marker, MAP);
		});

         // Clusterer
          const externalSvgRenderer = {
            render({ count, position }) {
              return new google.maps.Marker({
                position,
                icon: {
                  url: `${site_url}assets/svg/map-clusterer.svg`, 
                  scaledSize: new google.maps.Size(48, 48),
                  anchor: new google.maps.Point(24, 24)
                },
                label: {
                  text: String(count),
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: 'bold'
                },
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
              });
            }
          };
          
         new markerClusterer.MarkerClusterer({ map: MAP, markers: markers,renderer: externalSvgRenderer  });

        return $GoogleMaps = MAP;
    };

    const { lat, long } = config.hotel_pin,
        { map_zoom, snazzy } = config;

    setTimeout(() => {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            console.log('Google Maps API is ready', google.maps);
            InitializeMap(lat, long, map_zoom, snazzy);
        }
    }, 1000);
}


/***
 * Load marker to map
 ***/
function loadMarker(pin, map_selector, icon) { //writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.

	let { id, name, lat, long } = pin;

	// create new marker
	let marker = new google.maps.Marker({
		id: id,
		map: map_selector,
		title: name,
		icon: marker_url,
		zIndex: 1,
		position: new google.maps.LatLng(lat, long)
	});

	// let nameMarkerOnHover = getPinMarkUpHover(pin);

	// let nameMarkerOnHover1 = new google.maps.InfoWindow({
	// 	content: nameMarkerOnHover
	// });

	marker.addListener('mouseover', function () {
		//nameMarkerOnHover1.open(map_selector, marker);
		marker.setIcon(marker_hover_url);
	})

	marker.addListener('mouseout', function () {
		//nameMarkerOnHover1.close(map_selector, marker);
		marker.setIcon(marker_url);
	})

	marker.addListener('click', event => OpenLightbox(marker.id));
	//console.log(marker);
	return marker;
	

}

function getPinMarkUpHover(pin) { 
	const { id, name, description, address, image, phone, link_tel,logo, promo} = pin;

	let markup = name;

	return markup;
}

function OpenLightbox(element) {
	//Get Pin ID and then info
	const PinInfo = pinsData[element];
	//Get Pin Info

	  console.log( PinInfo );

	let markup = getPinMarkLighbox(PinInfo);
	LIGHTBOX_WRAPPER.innerHTML = markup;
	//document.querySelector("body").style.overflowY = 'hidden';
	LIGHTBOX__FULL_WRAPPER.classList.add(LIGHTBOX_OPENED__CLASS);
}

function CloseLigthbox(event) {
	if (event.keyCode === undefined && !event.target.classList.contains(LIGHTBOX_OPENED__CLASS) && event.target.id !== LIGHTBOX__CLOSE_BUTTON) return false;
	LIGHTBOX_WRAPPER.innerHTML = "";
	LIGHTBOX__FULL_WRAPPER.classList.remove(LIGHTBOX_OPENED__CLASS);
	document.querySelector("body").style.overflowY = 'visible';
}
if(LIGHTBOX__FULL_WRAPPER){
  LIGHTBOX__FULL_WRAPPER.addEventListener('click', (event) => CloseLigthbox(event));
  $LIGHTBOX__CLOSE_BUTTON.addEventListener('click', (event) => CloseLigthbox(event));
}

function getPinMarkLighbox(pin) { 
	const { id, name, description, address, image, phone, link_tel,logo, promo, marsha, website} = pin;
	console.log(marsha);
	let html_logo = '';
	if( logo )
		html_logo = `<div class="logo"><img src="${logo}"></div>`

	let markup = `<article data-attraction="${id}" class="offers-search__item offer" data-name="${name}">
					<figure class="offer__image">
						<img src="${image}" alt="offer image">
					</figure>
					<div class="offer__content">
						
						<div class="offer__hotel">${name}</div>
						<div class="offer__address">
							${address}<br>
							<a href="tel:${link_tel}">${phone}</a>
						</div>
						<div class="offer__excerpt">
							${description}
						</div>
						<a href="https://marriottbonvoyevents.com/tour/${marsha}"  class="btn custom_click_track" target="_blank" data-custom_click_track_value="Body: map- ${name}|Hotel Site Click|external|event450${marsha}">Learn More</a>
					</div>
				</article>`;

	return markup;
}

function matchOfferWithMarkers() {

	let tmpGetAttractionFromList = document.querySelectorAll("article[data-key]");

	let getAttractionFromList = {};
	tmpGetAttractionFromList.forEach(function (itemAttr) {
		let titleAttrBox = itemAttr.getAttribute('data-name');
		getAttractionFromList[titleAttrBox] = itemAttr;
	});

	//console.log(GoogleMapsMarkers);

	GoogleMapsMarkers.forEach(function (itemMarker) {

		let titleMarker = itemMarker.title;

		if (getAttractionFromList.hasOwnProperty(titleMarker)) {
			let attractionBox = getAttractionFromList[titleMarker];
			let nameMarkersOnHover = getPinMarkUpHover(pinsData[attractionBox.getAttribute('data-key')]);

			let infowindows = new google.maps.InfoWindow({
				content: nameMarkersOnHover
			});

			attractionBox.addEventListener('mouseover', function () {
				//itemMarker.setIcon(iconHover);
				infowindows.open(MAP, itemMarker);
			})

			attractionBox.addEventListener('mouseout', function () {
				//itemMarker.setIcon(iconDefault);
				infowindows.close(MAP, itemMarker);
			})
		}

	})
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}